import { Link } from 'react-router-dom';

/**
 * v2 Tender Overview — placeholder.
 *
 * The real component will be built from the approved wireframe
 * (see redesign-docs/wireframes.html, page 1: Tender Overview).
 *
 * Until then, this stub keeps /v2/tenders routable so the soft-launch
 * toggle has a valid destination. v1 remains the default at /tenders.
 */
export default function TenderOverview() {
  return (
    <div className="max-w-2xl mx-auto mt-12">
      <div className="rounded-xl border border-gray-200 bg-white p-8 shadow-sm">
        <div className="flex items-center gap-2 mb-4">
          <span className="inline-flex items-center rounded-full bg-amber-50 text-amber-700 border border-amber-200 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider">
            Under construction
          </span>
          <span className="text-[11px] font-mono text-gray-400">v2 · /v2/tenders</span>
        </div>

        <h1 className="text-2xl font-bold text-gray-900">Tender Overview</h1>
        <p className="mt-2 text-sm text-gray-600">
          The redesigned tender overview will live here, based on the approved wireframe.
          For now, please use the classic version.
        </p>

        <div className="mt-6 flex items-center gap-3">
          <Link
            to="/tenders"
            className="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 text-sm font-medium px-3.5 py-2"
          >
            <span>←</span>
            <span>Back to classic tenders</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
